<template>
      <search-panel mode="ver">
        <a-row slot="search"> 
          <a-col>
            <a-input-search 
              type='textarea' 
              style="padding: 4px;"
              placeholder="请输入要查询的内容, 如客户公司名称、业务简介、关键词等" 
              rows="3" 
              v-model="tp_keywords" 
              @change="inputChange" 
              id="content"/>
          </a-col> 
          <a-col>
            <a style="position: absolute; top: -40px; right: 180px; z-index: 3;" @click="selectAll">
              <select-all style="margin-top: 6px; height: 20px; width: 20px;"/>
            </a>
            <a style="position: absolute; top: -40px; right: 150px; z-index: 3;" @click="tagClick">
              <a-icon type="tag" style="font-size: 16px; padding-top: 8px; color: #1890ff;"/>
            </a>
            <a style="position: absolute; top: -40px; right: 120px; z-index: 3;" @click="statsClick">
              <a-icon type="line-chart" style="font-size: 16px; padding-top: 8px; color: #1890ff;"/>
            </a>
            <a-checkbox style="padding-top: 8px; padding-bottom: 10px; margin-right: 8px; float: right; position: absolute; top: -42px; right: 15px; z-index: 2;" 
                @change="mydataSearch($event)" :checked="mydata">仅限关注
            </a-checkbox>
            <a @click="advSearch($event)" :class="moreOrLess" style="position: absolute; top: -40px; right: 2px; z-index: 1;">
                    <svg t="1566386569321" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4255" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16"><path d="M991.744 763.904l-102.4-50.176c-4.608-2.048-9.728-2.048-14.336 0l-338.944 166.4c-14.848 7.168-32.768 7.168-47.616 0l-338.944-166.4c-4.608-2.048-9.728-2.048-14.336 0l-102.4 50.176c-12.8 6.144-12.8 24.576 0 30.72l455.68 223.744c14.848 7.168 32.768 7.168 47.616 0l455.68-223.744c12.8-6.144 12.8-24.064 0-30.72z" p-id="4256" fill="#1296db"></path><path d="M991.744 499.712l-102.4-50.176c-4.608-2.048-9.728-2.048-14.336 0l-338.944 166.4c-14.848 7.168-32.768 7.168-47.616 0L148.992 449.536c-4.608-2.048-9.728-2.048-14.336 0l-102.4 50.176c-12.8 6.144-12.8 24.576 0 30.72l455.68 223.744c14.848 7.168 32.768 7.168 47.616 0l455.68-223.744c13.312-6.144 13.312-24.576 0.512-30.72z" p-id="4257" fill="#1296db"></path><path d="M488.448 483.328l-455.68-223.744c-12.8-6.144-12.8-24.576 0-30.72L488.448 5.12c14.848-7.168 32.768-7.168 47.616 0l455.68 223.744c12.8 6.144 12.8 24.576 0 30.72l-455.68 223.744c-15.36 7.168-32.768 7.168-47.616 0z" p-id="4258" fill="#808080"></path></svg>
            </a>
            <a>
              <a-icon type="search" style="font-size: 20px; position: absolute; top: 28px; right: 2px; z-index: 1;" @click="searchEnt()"></a-icon>
            </a>
          </a-col>
        </a-row>
        <a-row slot="filter">
          <a-row class="pb8">
            <multi-selector v-if="advanced_search" style="padding: 0px 0px 4px 0px;" holder="企业注册地区" :span="24" :items="province" :fields="['province', 'city', 'county']" :defaultvalue="proDefault" @selected="selected"/>
          </a-row>
          <a-row class="pb8">
            <multi-selector v-if="advanced_search" style="padding: 0px 0px 4px 0px;" holder="企业所属行业" :span="24" :items="industry" :fields="['industry', 'subindustry']" :defaultvalue="indDefault" @selected="selected"/>
          </a-row>
          <a-row class="pb8">
            <ea-selector v-if="advanced_search" style="padding: 0px 0px 4px 0px;" :xs="24" :sm="24" :md="24" :lg="12" :xl="12" mode="tags" holder="企业类型" :items="entTypes" :defaultvalue="etDefault" field="enttype" @selected='selected'/>
            <ea-selector v-if="advanced_search" :style="secondFilterBoxStyle" :xs="24" :sm="24" :md="24" :lg="12" :xl="12" mode="tags" holder="营业状态" :items="entStatus" :defaultvalue="esDefault" field="entstatus" @selected='selected'/>
          </a-row>
          <a-row class="pb8">
            <ea-selector v-if="advanced_search" style="padding: 0px 0px 4px 0px;" :xs="24" :sm="24" :md="24" :lg="12" :xl="12" mode="tags" holder="注册资金" :items="entReg" :defaultvalue="erDefault" field="reged_cap" @selected='selected'/>
            <ea-selector v-if="advanced_search" :style="secondFilterBoxStyle" :xs="24" :sm="24" :md="24" :lg="12" :xl="12" mode="tags" holder="成立年限" :items="entTime" :defaultvalue="eiDefault" field="esdate" @selected='selected'/>
          </a-row>
          <a-row class="pb8">
            <ea-selector v-if="advanced_search" :xs="24" :sm="24" :md="24" :lg="12" :xl="12" style="padding: 0px 0px 4px 0px;" mode="tags" holder="联系方式" :items="entContact" :defaultvalue="ecDefault" field="contact" @selected='selected'/>
            <ea-selector v-if="mydata" :xs="24" :sm="24" :md="24" :lg="tags_box_size" :xl="tags_box_size" :style="secondFilterBoxStyle" mode="tags" holder="自定义标签" :items="mytags" :defaultvalue="tgDefault" field="mytags" @selected='selected' @focus="getTagList"/>
          </a-row>
        </a-row>
      </search-panel>
</template>

<script>
import {MultiSelector, EaSelector} from '@/com/Selector'
import {SearchPanel} from '@/com/Basic'
import SelectAll from '@/assets/img/SelectAll.vue';

import entData from '@/meta/entdata.js'
import pr from '@/meta/province.js'
import idy from '@/meta/industry.js'

export default {
  name: 'EntSearch',
  data() {
    return {
      tp_keywords: this.keywords,
      advanced_search : false, 
      tags_box_size : 24, 
      secondFilterBoxStyle : "padding: 0px 0px 4px 0px",
      moreOrLess: "more", 
      mydata: false,
      province: pr.data,
      proDefault: [],
      industry: idy.idy,
      indDefault: [],
      entTypes: entData.types,
      etDefault: "",
      entStatus: entData.status,
      esDefault: "",
      entReg: entData.reg,
      erDefault: "",
      entTime: entData.time,
      eiDefault: "",
      entContact: entData.contact,
      ecDefault: "",
      mytags: []
    }
  },
  props: {
    postdata: {},
    keywords: {}
  },
  components: {
    MultiSelector,
    EaSelector,
    SearchPanel,
    SelectAll
  },
  watch: {
    keywords(newvalue, oldvalue) {
      this.tp_keywords = newvalue;
      this.keywords = newvalue;
    },
    tp_keywords(newvalue, oldvalue) {
      this.tp_keywords = newvalue;
      this.keywords = newvalue;
    }
  },
  methods: {
    selected: function(data, type) {
      if (type == false) {
        for (let key in data) {
          if (data[key] == false) {
            delete this.postdata[key]
          } else {
            this.postdata[key] = data[key]
          }
        }
      }
      if (type) {
        this.postdata[type] = data
      }
    },
    selectAll: function() {
      this.$emit("selectall");
    },
    tagClick: function() {
      let relationitem = this.$store.getters.getRelationItem();
      if (!relationitem) {
        this.$message.loading("请选择企业!");
        return;
      }
      let size = 0;
      let names = "";
      for (let key in relationitem) {
        size += 1;
        names = names + " " + key;
      }
      if (size == 0) {
        this.$message.loading("请选择企业!");
      } else {
        let postdata = {
          task: "ICI_USER_TAGS",
          utags: "true"
        }
        let that = this
        that.post('enterprise', postdata)
          .then(function(data) {
            if (data.ret == 200) {
              that.$emit("tagging", names, data.data);
            }
          }).catch(function (e) {
            console.log(e)
        });
      }
    },
    statsClick: function() {
      let inputs = this.tp_keywords.split("\n");
      this.postdata["content"] = inputs[inputs.length - 1]; 
      delete this.postdata["entnames"]
      if (inputs.length > 1) {
        let entnames = ""
        for (let i = 0; i < inputs.length - 1; i++) {
          entnames = entnames + " " + inputs[i]
        }
        this.postdata["entname"] = entnames
      } else {
        delete this.postdata["entname"]
      } 
      if (this.mydata) {
        this.postdata["mydata"] = true
      } else {
        delete this.postdata["mydata"]
      }
      this.postdata["task"] = "ICI_SIMILAR_ENT"
      this.postdata["stats"] = true
      let that = this
      let loading = that.$message.loading("分析中...", 0);
      that.post('enterprise', that.postdata)
        .then(function(data) {
          setTimeout(loading, 0);
          that.$emit('stats', data.stats);
        }).catch(function (e) {
          console.log(e);
          setTimeout(loading, 0);
          that.$message.error("分析失败")
      })
    },
    getTagList: function() {
      let postdata = {
        task: "ICI_USER_TAGS"
      }
      let that = this
      that.post('enterprise', postdata)
        .then(function(data) {
          if (data.ret == 200) {
            that.mytags = data.data
          }
        }).catch(function (e) {
          console.log(e)
      });
    },

    set2ndFilterBoxStyle: function() { 
      if (document.body.clientWidth >= 992) 
      {
        if (this.tags_box_size == 12) 
            this.secondFilterBoxStyle = "padding: 0px 0px 4px 4px;"; 
        else
            this.secondFilterBoxStyle = "padding: 0px 0px 4px 0px;"; 
      }
      else 
        this.secondFilterBoxStyle = "padding: 0px 0px 4px 0px;"; 
    }, 

    advSearch: function(e) {
      this.advanced_search = !this.advanced_search; 
      this.moreOrLess = ( this.advanced_search ? "less" : "more" ); 

      this.tags_box_size = (this.advanced_search ? 12 : 24); 
      
      this.set2ndFilterBoxStyle(); 
    },

    mydataSearch: function(e) {
      if (e.target.checked) {
        this.mydata = true
      } else {
        this.mydata = false
        delete this.postdata["mytags"]
      }

      this.tags_box_size = (this.advanced_search ? 12 : 24); 
      this.set2ndFilterBoxStyle(); 
    },
    inputChange: function(value) {
      let content = this.tp_keywords;
      this.$emit('inputchange', content);
    },
    searchEnt: function() {
      let page = 1;
      this.postdata["moreOrLess"] = this.moreOrLess; 
      this.postdata["page"] = page; 
      this.postdata["from"] = (page - 1) * 20; 
      this.postdata["to"] = page * 20; 
      let inputs = this.tp_keywords.split("\n");
      this.postdata["content"] = inputs[inputs.length - 1]; 
      delete this.postdata["entnames"]
      delete this.postdata["stats"]
      if (inputs.length > 1) {
        let entnames = ""
        for (let i = 0; i < inputs.length - 1; i++) {
          entnames = entnames + " " + inputs[i]
        }
        this.postdata["entname"] = entnames
      } else {
        delete this.postdata["entname"]
      } 
      if (this.mydata) {
        this.postdata["mydata"] = true
      } else {
        delete this.postdata["mydata"]
      }
      this.postdata["task"] = "ICI_SIMILAR_ENT"
      this.postdata["api-path"] = "enterprise"
      let that = this
      let loading = that.$message.loading("搜索中...", 0);
      that.post('enterprise', that.postdata)
        .then(function(data) {
          setTimeout(loading, 0);
          that.$store.commit('updatepostdata', {post: that.postdata, tab: 'ent'});
          that.$store.commit('updateresult', {result: data.data, tab:'ent'});
          //that.$store.commit('updaterelationitem', {});
          that.$emit('search', that.postdata, data.data, {});
        }).catch(function (e) {
          console.log(e);
          setTimeout(loading, 0);
          that.$message.error("查询失败")
      })
    }
  },
  created() {
    if (this.postdata.mydata) {
      this.mydata = true
    }

    if (this.postdata.moreOrLess){
      //console.log("In created: postdata.moreOrLess: " + this.postdata.moreOrLess);  
      this.moreOrLess = this.postdata.moreOrLess; 
      this.advanced_search = (this.moreOrLess == "less"); 
    }

    let deviceWidth = document.body.clientWidth

    if (deviceWidth >= 992)
    { 
        if (this.advanced_search) 
            this.tags_box_size = 12; 
        else
            this.tags_box_size = 24; 
    }
    else
        this.tags_box_size = 24; 

    this.set2ndFilterBoxStyle(); 
    
    //console.log("In created: "); 
    //console.log("clientWidth: " + document.body.clientWidth); 
    //console.log("this.tags_box_size:" + this.tags_box_size); 
    //console.log("this.secondFilterBoxStyle:" + this.secondFilterBoxStyle); 

    if (this.postdata.province) {
      this.proDefault.push(this.postdata.province)      
    } else {
      this.proDefault.push("")
    }
    if (this.postdata.city) {
      this.proDefault.push(this.postdata.city)
    } else {
      this.proDefault.push("")
    }
    if (this.postdata.county) {
      this.proDefault.push(this.postdata.county)
    } else {
      this.proDefault.push("")
    }
    if (this.proDefault[0] == "") { 
      this.proDefault = undefined
    }

    if (this.postdata.industry) {
      this.indDefault.push(this.postdata.industry)
    } else {
      this.indDefault.push("")
    }
    if (this.postdata.subindustry) {
      this.indDefault.push(this.postdata.subindustry)
    } else {
      this.indDefault.push("")
    }

    if (this.indDefault[0] == "") {
      this.indDefault = undefined
    }

    if (this.postdata.enttype) {
      this.etDefault = this.postdata.enttype
    } else {
      this.etDefault = undefined
    }
    if (this.postdata.entstatus) {
      this.esDefault = this.postdata.entstatus
    } else {
      this.esDefault = undefined
    }
    if (this.postdata.reged_cap) {
      this.erDefault = this.postdata.reged_cap
    } else {
      this.erDefault = undefined
    }
    if (this.postdata.esdate) {
      this.eiDefault = this.postdata.esdate
    } else {
      this.eiDefault = undefined
    }
    if (this.postdata.contact) {
      this.ecDefault = this.postdata.contact
    } else {
      this.ecDefault = undefined
    }

    if (this.postdata.mytags) {
      this.tgDefault = this.postdata.mytags
    } else {
      this.tgDefault = undefined
    }

    /*let postdata = {
      task: "ICI_USER_TAGS"
    }
    let that = this
    that.post('enterprise', postdata)
      .then(function(data) {
        if (data.ret == 200) {
          that.mytags = data.data
        }
      }).catch(function (e) {
      console.log(e)
    });*/
  }
}
</script>

<style scoped>
  .pb8 {
    padding-bottom: 0px;
  }

  .more { 
      padding-top: 10px; 
      padding-bottom: 4px; 
      margin-right: 4px; 
      float: right;
  }

  .less { 
      padding-top: 4px; 
      padding-bottom: 4px; 
      margin-right: 4px; 
      float: right;
      transform:          rotate(180deg);
      -ms-transform:      rotate(180deg);
      -moz-transform:     rotate(180deg);
      -webkit-transform:  rotate(180deg);
      -o-transform:       rotate(180deg);
  }

  .card-border {
    border-top: 0px;
    border-bottom: 1px solid #e1e4e8;
    border-left: 0px;
    border-right: 0px;
  }

  .text-split {
    font-size: 14px;
    word-break:break-all;
    display:-webkit-box;
    -webkit-line-clamp:2;
    -webkit-box-orient:vertical;
    overflow:hidden;
  }
  .mb4 {
    margin-bottom: 4px;
  }
</style>
